import React, {Component} from 'react'
import {Alert, Button, Card, Descriptions, Result, Space, Spin, Typography} from 'antd'
import {getUserDetail, confirmCliDeviceLogin} from '../../request'

const {Text, Paragraph} = Typography

/**
 * lechun-cli 设备授权页。
 *
 * 流程：CLI 调 /cli/auth/login/start 拿到 state 与 loginUrl，打开本页；
 * 用户在本页确认后，页面调 /cli/auth/confirm 把当前登录身份绑定到 state；
 * CLI 轮询 /cli/auth/login/poll 换取 token。
 */
class CliLogin extends Component {
    state = {
        state: '',
        loading: true,
        submitting: false,
        user: null,
        success: false,
        error: '',
    }

    componentDidMount() {
        // 直接读 window.location，避免 noPortalSide 路由传入的 location 覆盖缺少 search 字段
        const params = new URLSearchParams(window.location.search)
        const state = params.get('state') || ''
        if (!state) {
            this.setState({
                loading: false,
                error: '缺少授权参数，请回到终端重新执行 lechun-cli auth login',
            })
            return
        }
        this.setState({state})
        // 未登录时接口返回 20112，全局拦截器会清理本地登录态并跳转登录页，
        // 登录成功后带 returnPage 回到本页。
        getUserDetail({})
            .then(user => {
                this.setState({loading: false, user: user || null})
            })
            .catch(() => {
                this.setState({loading: false, user: null})
            })
    }

    handleConfirm = () => {
        if (this.state.submitting || !this.state.state) {
            return
        }
        this.setState({submitting: true, error: ''})
        confirmCliDeviceLogin({state: this.state.state})
            .then(() => {
                this.setState({submitting: false, success: true})
            })
            .catch(err => {
                this.setState({
                    submitting: false,
                    error: (err && err.message) || '授权失败，请回到终端重新执行登录',
                })
            })
    }

    renderLoading() {
        return (
            <div style={{textAlign: 'center', padding: '48px 0'}}>
                <Spin tip="正在检查登录状态..."/>
            </div>
        )
    }

    renderSuccess() {
        return (
            <Result
                status="success"
                title="授权成功"
                subTitle="可以关闭当前标签页了，请回到终端继续操作。"
            />
        )
    }

    renderError() {
        return (
            <Result
                status="warning"
                title="授权未完成"
                subTitle={this.state.error}
            />
        )
    }

    renderConfirm() {
        const {user, submitting, error} = this.state
        const displayName = user
            ? `${user.userNick || user.userName || user.userId || '-'}${
                  user.userName && user.userNick && user.userNick !== user.userName
                      ? `（${user.userName}）`
                      : ''
              }`
            : '-'
        return (
            <Card title="乐纯 CLI 设备授权" bordered={false} style={{maxWidth: 560, margin: '0 auto'}}>
                <Space direction="vertical" size="middle" style={{width: '100%'}}>
                    <Alert
                        type="warning"
                        showIcon
                        message="请确认这是你本人发起的登录"
                        description="确认后，该设备上的 lechun-cli 将以你的身份访问乐纯系统。如果你没有在终端执行 lechun-cli auth login，请直接关闭本页。"
                    />
                    <Descriptions column={1} size="small" bordered>
                        <Descriptions.Item label="当前账号">{displayName}</Descriptions.Item>
                        <Descriptions.Item label="授权内容">
                            <Text type="secondary">
                                开通空间、创建/查看/删除 Vibe 项目、读取项目变量
                            </Text>
                        </Descriptions.Item>
                    </Descriptions>
                    {error ? <Alert type="error" showIcon message={error}/> : null}
                    <Paragraph type="secondary" style={{marginBottom: 0}}>
                        授权有效期 30 天，可随时在 CLI 执行 lechun-cli auth logout 撤销。
                    </Paragraph>
                    <Space>
                        <Button type="primary" loading={submitting} onClick={this.handleConfirm}>
                            确认授权
                        </Button>
                    </Space>
                </Space>
            </Card>
        )
    }

    render() {
        const {loading, success, error} = this.state
        let content
        if (loading) {
            content = this.renderLoading()
        } else if (success) {
            content = this.renderSuccess()
        } else if (error) {
            content = this.renderError()
        } else {
            content = this.renderConfirm()
        }
        return (
            <div style={{minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24}}>
                {content}
            </div>
        )
    }
}

export default CliLogin
